module.exports = __webpack_public_path__ + "static/media/linkedin-brands.d9049f46.svg";